import React, { useState } from 'react';
import {
  Box,
  TextField,
  Button,
  Typography,
  Chip,
} from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';

interface KeywordsFieldProps {
  keywords: string[];
  onChange: (keywords: string[]) => void;
}

const KeywordsField: React.FC<KeywordsFieldProps> = ({ keywords = [], onChange }) => {
  const [keywordInput, setKeywordInput] = useState('');

  const handleAddKeyword = () => {
    if (keywordInput.trim() && !keywords.includes(keywordInput.trim())) {
      onChange([...keywords, keywordInput.trim()]);
      setKeywordInput('');
    }
  };

  const handleRemoveKeyword = (keywordToRemove: string) => {
    onChange(keywords.filter(keyword => keyword !== keywordToRemove));
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
      <Typography variant="subtitle1">Ключевые слова</Typography>
      <Box sx={{ display: 'flex', gap: 1 }}>
        <TextField
          fullWidth
          value={keywordInput}
          onChange={(e) => setKeywordInput(e.target.value)}
          placeholder="Введите ключевое слово"
          onKeyPress={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              handleAddKeyword();
            }
          }}
        />
        <Button
          variant="contained"
          onClick={handleAddKeyword}
          startIcon={<AddIcon />}
        >
          Добавить
        </Button>
      </Box>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mt: 1 }}>
        {keywords.map((keyword) => (
          <Chip
            key={keyword}
            label={keyword}
            onDelete={() => handleRemoveKeyword(keyword)}
          />
        ))}
      </Box>
    </Box>
  );
};

export default KeywordsField; 